import "styles/pages/page-new-vehicles.scss";
import React, { useState } from "react";
import { graphql } from "gatsby";

import Layout from "components/Layout";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import NewVehicleTile from "components/NewVehicleTile/NewVehicleTile";
import SectionHeader from "components/SectionHeader/SectionHeader";
import TeamPersonTile from "components/TeamPersonTile/TeamPersonTile";
import AvailableVehiclesSlider from "components/AvailableVehiclesSlider/AvailableVehiclesSlider";

const NewVehiclesList = ({ data, pageContext }) => {
  const pageContent = pageContext.pageContent;
  const availableVehicles = data.availableVehicles.edges;
  const brands = pageContext.pageContent.brands;
  const seo = pageContext.seo;

  return (
    <Layout>
      <Seo title={seo.title} description={seo.metaDesc} />
      <SubpageHeader
        title={pageContent.title}
        crumbFirstLabel="pojazdy kempingowe"
        location="nowe kampery i przyczepy"
      />
      <section className="new-vehicles-about">
        <div className="container">
          <div className="new-vehicles-about__text">{pageContent.desc}</div>
        </div>
      </section>
      <section className="new-vehicles-list">
        <div className="container">
          <div className="row">
            {brands?.map((node, index) => {
              const vehicleType =
                node.fieldGroupName === "Page_Newvehiclespage_Brands_Trailer"
                  ? "trailer"
                  : "vehicle";
              return vehicleType === "trailer" ? (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <NewVehicleTile
                    thumbnail={
                      node.singleTrailer.trailersBrandCategory?.tileImage
                        .sourceUrl
                    }
                    logo={
                      node.singleTrailer.trailersBrandCategory?.logoSmall
                        .sourceUrl
                    }
                    category="przyczepy"
                    link={node.singleTrailer.uri}
                  />
                </div>
              ) : (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <NewVehicleTile
                    thumbnail={
                      node.singleVehicle.vehiclesBrandCategory?.tileImage
                        .sourceUrl
                    }
                    logo={
                      node.singleVehicle.vehiclesBrandCategory?.logoSmall
                        .sourceUrl
                    }
                    category="kampery"
                    link={node.singleVehicle.uri}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="new-vehicles-available">
        <div className="container">
          {/* <AvailableVehiclesSlider vehicles={availableVehicles} /> */}
        </div>
      </section>
      <section className="new-vehicles-team">
        <div className="container">
          <SectionHeader
            title="Dział sprzedaży pojazdów kempingowych"
            subtitle="NASZ ZESPÓŁ"
            reversed={true}
          />
          <div className="row">
            {pageContent.persons?.map((node, index) => {
              const person = node.singleTeam;
              return (
                <div className="col-md-3" key={index}>
                  <TeamPersonTile
                    name={person.fullname}
                    jobName={person.jobname}
                    avatar={person.avatar?.sourceUrl}
                    phone={person.phone}
                    email={person.email}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query allBrands {
    availableVehicles: allWpVehicle(
      filter: { vehicles: { available: { eq: true } } }
    ) {
      edges {
        node {
          uri
          slug
          vehicles {
            available
            name
            gallery {
              sourceUrl
            }
          }
          vehiclesBrand {
            nodes {
              vehiclesBrandCategory {
                logoSmall {
                  sourceUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default NewVehiclesList;
